/* unplugin-vue-components disabled */import script from "./RolePocket.vue?vue&type=script&setup=true&lang=js"
export * from "./RolePocket.vue?vue&type=script&setup=true&lang=js"

import "./RolePocket.vue?vue&type=style&index=0&id=425d712d&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425d712d"]])

export default __exports__